const v8pagination = {
  forms: document.querySelectorAll('.v8Form'),

  init() {
    const parentObj = this;
    for (const form of this.forms) {
      parentObj.checkButtons(form);

      // Initialize validation before attaching handlers so a failed third-party
      // script cannot leave behind a click handler with an undefined validator.
      form.pristine = parentObj.createValidator(form);

      form.addEventListener('click', this.handleListeners(parentObj, form));
      form.addEventListener('keypress', this.accessibleKeyboardInteractivity(form));
    }
  },

  createValidator: function (form) {
    if (typeof window.Pristine !== 'function') {
      console.error('V8 form validation library failed to load; using browser validation.');
      return null;
    }

    return new window.Pristine(form.querySelector('.v8Form__form'), {
      classTo: 'v8Fields__field',
      errorClass: 'has-danger',
      successClass: 'has-success',
      errorTextParent: 'v8Fields__field',
      errorTextTag: 'div',
      errorTextClass: 'text-help',
    });
  },

  validateFields: function (form, inputs) {
    if (form.pristine) {
      return form.pristine.validate(inputs);
    }

    const invalidInput = Array.from(inputs).find((input) => !input.checkValidity());

    if (!invalidInput) {
      return true;
    }

    if (typeof invalidInput.reportValidity === 'function') {
      invalidInput.reportValidity();
    }

    return false;
  },

  handleListeners: function (parentObj, form) {
    return function (event) {
      const button = event.target.closest('.v8Form__button');

      if (button) {
        parentObj.processButtonClicks(form, event, parentObj, button);
      }

      if (event.target.matches('.v8Form__single-step')) {
        parentObj.processMenuClicks(form, event, parentObj);
      }
    };
  },

  processButtonClicks: function (form, event, parentObj, button) {
    const fields = form.querySelector('.v8Fields');
    const activePage = fields.querySelector('.activePage');
    const pageNumber = parseInt(activePage.dataset.pagenumber);

    // Next Button
    if (button.matches('.v8Form__next')) {
      const nextPage = fields.querySelector(`[data-pagenumber="${pageNumber + 1}"]`);
      const targetStep = form.querySelector(`.v8Form__single-step[data-pagenumber="${pageNumber + 1}"]`);

      // Validate the current step using Pristine before proceeding to the next page
      const inputs = activePage.querySelectorAll('input, textarea, select');
      const isValid = parentObj.validateFields(form, inputs);

      if (isValid) {
        targetStep.focus();
        activePage.classList.remove('activePage');
        nextPage.classList.add('activePage');
        parentObj.markCompletedPages(form, pageNumber + 1);
      }
    }

    // Previous Button
    if (button.matches('.v8Form__previous')) {
      const prevPage = fields.querySelector(`[data-pagenumber="${pageNumber - 1}"]`);
      activePage.classList.remove('activePage');
      prevPage.classList.add('activePage');
      parentObj.markCompletedPages(form, pageNumber - 1);
    }

    // Submit Button
    if (button.matches('.v8Form__submit')) {
      event.preventDefault();
      parentObj.validateForm(form, parentObj);
    }

    parentObj.checkButtons(form);
  },

  checkButtons(form) {
    const steps = form.querySelectorAll('.v8Form__single-step');
    const activePage = form.querySelector('.activePage');
    const previousButton = form.querySelector('.v8Form__previous');
    const nextButton = form.querySelector('.v8Form__next');
    const submitButton = form.querySelector('.v8Form__submit');

    // Page 1 - Show only Continue
    if (parseInt(activePage.dataset.pagenumber) === 1) {
      previousButton.style.display = 'none';
      submitButton.style.display = 'none';
      nextButton.style.display = 'inline-block';
    }

    // Middle Pages - Show Return and Continue
    if (parseInt(activePage.dataset.pagenumber) > 1 && parseInt(activePage.dataset.pagenumber) < steps.length) {
      previousButton.style.display = 'inline-block';
      nextButton.style.display = 'inline-block';
      submitButton.style.display = 'none';
    }

    // End Page - Show Submit
    if (parseInt(activePage.dataset.pagenumber) === steps.length) {
      previousButton.style.display = 'inline-block';
      nextButton.style.display = 'none';
      submitButton.style.display = 'inline-block';
    }
  },

  processMenuClicks(form, event, parentObj) {
    const steps = form.querySelectorAll('.v8Form__single-step');
    const fields = form.querySelector('.v8Fields');
    const activePage = fields.querySelector('.activePage');
    const pageNumber = parseInt(event.target.dataset.pagenumber);
    const targetPage = fields.querySelector(`[data-pagenumber="${pageNumber}"]`);
    for (const step of steps) {
      step.classList.remove('activeMenuItem');
    }
    event.target.classList.add('activeMenuItem');

    activePage.classList.remove('activePage');
    targetPage.classList.add('activePage');

    parentObj.checkButtons(form);
    parentObj.markCompletedPages(form);
  },

  markCompletedPages: function (form, pageNumber = null) {
    let stepCounter = 0;
    const steps = form.querySelector('.v8Form__steps');

    if (pageNumber) {
      const targetStep = steps.querySelector(`[data-pagenumber="${pageNumber}"]`);

      const activeStep = steps.querySelector('.activeMenuItem');
      targetStep.classList.add('activeMenuItem');
      activeStep.classList.remove('activeMenuItem');
    }

    for (const step of steps.children) {
      step.classList.remove('completedMenuItem');
    }

    while (!steps.children[stepCounter].classList.contains('activeMenuItem')) {
      steps.children[stepCounter].classList.add('completedMenuItem');
      stepCounter++;
    }
  },

  validateForm: function (form, parentObj) {
    const formEl = form.querySelector('.v8Form__form');
    formEl.classList.add('v8-submitting');

    const spinner = document.createElement('div');
    spinner.classList.add('v8-spinner');
    spinner.innerHTML = `<div class="v8-spinner-container"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>`;
    form.querySelector('.v8-submitting').parentElement.appendChild(spinner);

    const valid = form.pristine
      ? form.pristine.validate()
      : typeof formEl.reportValidity === 'function'
      ? formEl.reportValidity()
      : formEl.checkValidity();

    if (!valid) {
      alert('The form is missing items. Please go back and fill in all required items');

      if (form.pristine) {
        for (const field of form.pristine.fields) {
          if (field.input.className === 'flatpickr-input' && field.errors.length > 0) {
            form.pristine.addError(field.input, 'Please select a date');
          }
        }
      }

      formEl.classList.remove('v8-submitting');
      spinner.remove();
    } else {
      formEl.submit();
    }
  },

  accessibleKeyboardInteractivity: function (form) {
    return function (event) {
      if (event.target.classList.contains('v8Form__button')) {
        if (event.key === 'Enter') {
          event.preventDefault();
          event.target.click();
        }
      }

      if (event.target.classList.contains('v8Form__single-step')) {
        if (event.key === 'Enter') {
          event.preventDefault();
          event.target.click();
        }
      }

      if (event.target.classList.contains('v8Fields__radio-single')) {
        if (event.key === 'Enter') {
          event.target.click();
          event.firstChild.target.click();
        }
      }

      if (event.target.classList.contains('flatpickr-monthDropdown-months')) {
        if (event.key === 'Enter') {
          event.target.click();
        }
      }

      if (event.key === 'Enter') {
        const activePage = form.querySelector('.activePage');
        const formInputTypes = [
          'input',
          'textarea',
          'select',
          '.v8Fields__radio-single',
          '.flatpickr-day',
          '.flatpickr-monthDropdown-months',
          '.flatpickr-monthDropdown-month',
        ];

        formInputTypes.forEach((type) => {
          const pageInputs = activePage.querySelectorAll(type);
          const allInputs = form.querySelectorAll(type);

          for (const input of allInputs) {
            input.tabIndex = -1;
          }

          for (const input of pageInputs) {
            input.tabIndex = 0;
          }
        });
      }
    };
  },
}.init();
